import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import TimeAddOn from "@coworker/apprestructured/src/task-management/components/LogsAndComments/TimeAddOn/TimeAddOn";
import styles from "./CommentsTab.module.css";

type CommentsTabProps = {
  items: CommentsTabItem[];
};

export type CommentsTabItem = {
  title: string;
  content: string;
  time: string;
};

function CommentsTab({ items }: CommentsTabProps) {
  return (
    <>
      <FixaListView id="comments">
        {items.map(({ title, content, time }, i) => (
          <FixaListViewItem
            key={i}
            title={<span className={styles["title"]}>{title}</span>}
            description={
              <span className={styles["description"]}>{content}</span>
            }
            addOn={<TimeAddOn>{time}</TimeAddOn>}
            emphasised
            inset
          />
        ))}
      </FixaListView>
    </>
  );
}

export default CommentsTab;
